export default __webpack_public_path__ + "static/media/beach-football-icon.047dae72.svg";